import { useState } from "react";
import { toast } from "sonner";
import { Hash } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { useLoad } from "@/lib/useLoad";

export default function NumberingForm({ canEdit }) {
  const [rows, reload] = useLoad(() => api.get("/numbering").then((r) => r.data), []);
  const [edit, setEdit] = useState({});
  const save = async (prefix) => {
    const v = Number(edit[prefix]);
    if (!v) return;
    try {
      await api.put("/numbering", { prefix, next_seq: v });
      toast.success(`${prefix} serisi güncellendi`);
      setEdit({ ...edit, [prefix]: "" });
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="panel p-6" data-testid="numbering-form">
      <h3 className="mb-1 flex items-center gap-2 font-display text-lg font-bold"><Hash size={18} /> Otomatik Numaratör</h3>
      <p className="mb-4 text-xs text-muted-foreground">Sipariş, fatura ve diğer belgeler otomatik sıra numarası alır. Bir serinin sonraki numarasını ileri alabilirsiniz (geriye alınamaz).</p>
      <table className="w-full text-sm">
        <thead><tr className="text-left text-[11px] uppercase tracking-wider text-muted-foreground"><th className="pb-2">Seri</th><th className="pb-2">Belge</th><th className="pb-2">Sonraki No</th>{canEdit && <th className="pb-2">Yeni Sıra</th>}</tr></thead>
        <tbody>
          {(rows || []).map((r) => (
            <tr key={r.prefix} className="border-t border-border" data-testid={`numbering-row-${r.prefix}`}>
              <td className="py-2 font-num font-semibold">{r.prefix}</td>
              <td className="py-2 text-muted-foreground">{r.label}</td>
              <td className="py-2 font-num" data-testid={`numbering-next-${r.prefix}`}>{r.next}</td>
              {canEdit && (
                <td className="py-2">
                  <div className="flex items-center gap-2">
                    <Input type="number" min="1" className="h-8 w-28" placeholder="örn. 1001" value={edit[r.prefix] || ""} onChange={(e) => setEdit({ ...edit, [r.prefix]: e.target.value })} data-testid={`numbering-input-${r.prefix}`} />
                    <Button size="sm" variant="outline" className="rounded-[4px]" disabled={!edit[r.prefix]} onClick={() => save(r.prefix)} data-testid={`numbering-save-${r.prefix}`}>Kaydet</Button>
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
